export default __webpack_public_path__ + "locales/de/InviteDialog.json?hash=1b3d5c1ce3495e9898ae0687ba4ac983";